__turbopack_context__.v({
  "description": "TasksEmptyState-module-scss-module__Z7O68G__description",
  "icon": "TasksEmptyState-module-scss-module__Z7O68G__icon",
  "root": "TasksEmptyState-module-scss-module__Z7O68G__root",
  "text": "TasksEmptyState-module-scss-module__Z7O68G__text",
  "title": "TasksEmptyState-module-scss-module__Z7O68G__title",
});
